<!-- DELETE MODE: Using shared confirmation modal component (following @sharedcomponent.mdc pattern) -->
@if (mode === 'delete') {
<div>
  <gtw-confirmation-modal
    [config]="modalConfig"
    [visible]="showModal"
    (confirmed)="onConfirm()"
    (cancelled)="onCancel()"
    (closed)="onCancel()">
  </gtw-confirmation-modal>
</div>
}

<!-- INSERT MODE: Insert Table Record Form (from t_i.html) -->
@if (mode === 'insert') {
<div>
  <div class="modal-header">
    <h3 class="modal-title">
      Insert Table Record
      <i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
      <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    </h3>
  </div>

  @if (loading) {
<div class="modal-body">
    <div class="row formLoader">
      <div class="col-md-5"></div>
      <div class="col-md-2">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
      <div class="col-md-5"></div>
    </div>
  </div>
}

  @if (!loading) {
<div class="modal-body" [hidden]="minimise">
    <form [formGroup]="tblMaintenanceForm" name="screenFrom" class="form-horizontal" novalidate>
      <div style="margin: 12px;" class="row">
        <div class="col-md-6">
          <label>Table Name:</label>
          <select class="form-control dropdown-limited" [(ngModel)]="rSrcTbl" (ngModelChange)="changeTable()" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">Select</option>
            @for (tbl of tblList; track $index) {
<option [value]="tbl">{{tbl}}</option>
}
          </select>
        </div>
      </div>

      <div class="row" style="margin-top: 5px; margin-left: 12px;">
        <div class="col-md-4">
          <label>Run Sunday</label><br>
          <input style="margin-top: 10px; margin-right: 5px" type="radio" name="runSunday" [(ngModel)]="runSunYes" value="Yes" [ngModelOptions]="{standalone: true}"> Yes
          <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" name="runSunday" [(ngModel)]="runSunYes" value="No" [ngModelOptions]="{standalone: true}"> No
        </div>
        <div class="col-md-4">
          <label>Run Monday</label><br>
          <input style="margin-top: 10px; margin-right: 5px" type="radio" name="runMonday" [(ngModel)]="runMonYes" value="Yes" [ngModelOptions]="{standalone: true}"> Yes
          <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" name="runMonday" [(ngModel)]="runMonYes" value="No" [ngModelOptions]="{standalone: true}"> No
        </div>
        <div class="col-md-4">
          <label>Run Tuesday</label><br>
          <input style="margin-top: 10px; margin-right: 5px" type="radio" name="runTuesday" [(ngModel)]="runTueYes" value="Yes" [ngModelOptions]="{standalone: true}"> Yes
          <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" name="runTuesday" [(ngModel)]="runTueYes" value="No" [ngModelOptions]="{standalone: true}"> No
        </div>
      </div>

      <div class="row" style="margin-top: 5px; margin-left: 12px;">
        <div class="col-md-4">
          <label>Run Wednesday</label><br>
          <input style="margin-top: 10px; margin-right: 5px" type="radio" name="runWednesday" [(ngModel)]="runWenYes" value="Yes" [ngModelOptions]="{standalone: true}"> Yes
          <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" name="runWednesday" [(ngModel)]="runWenYes" value="No" [ngModelOptions]="{standalone: true}"> No
        </div>
        <div class="col-md-4">
          <label>Run Thursday</label><br>
          <input style="margin-top: 10px; margin-right: 5px" type="radio" name="runThursday" [(ngModel)]="runThuYes" value="Yes" [ngModelOptions]="{standalone: true}"> Yes
          <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" name="runThursday" [(ngModel)]="runThuYes" value="No" [ngModelOptions]="{standalone: true}"> No
        </div>
        <div class="col-md-4">
          <label>Run Friday</label><br>
          <input style="margin-top: 10px; margin-right: 5px" type="radio" name="runFriday" [(ngModel)]="runFriYes" value="Yes" [ngModelOptions]="{standalone: true}"> Yes
          <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" name="runFriday" [(ngModel)]="runFriYes" value="No" [ngModelOptions]="{standalone: true}"> No
        </div>
      </div>

      <div class="row" style="margin-top: 5px; margin-left: 12px;">
        <div class="col-md-4">
          <label>Run Saturday</label><br>
          <input style="margin-top: 10px; margin-right: 5px" type="radio" name="runSaturday" [(ngModel)]="runSatYes" value="Yes" [ngModelOptions]="{standalone: true}"> Yes
          <input style="margin-top: 10px; margin-left: 5px; margin-right: 5px;" type="radio" name="runSaturday" [(ngModel)]="runSatYes" value="No" [ngModelOptions]="{standalone: true}"> No
        </div>
        <div class="col-md-4">
          <label>Select Archive/Purge/Adhoc</label><br>
          <select class="form-control" [(ngModel)]="rSTbl" (ngModelChange)="changesName()" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">Select</option>
            @for (sTbl of sTblList; track $index) {
<option [value]="sTbl">{{sTbl}}</option>
}
          </select>
        </div>
        @if (showTbl) {
<div class="col-md-4">
          <label>Archive Table Name:</label><br>
          <select class="form-control dropdown-limited" [(ngModel)]="rArchiveTblName" (ngModelChange)="changeTable()" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null">Select</option>
            @for (tbl of tblList; track $index) {
<option [value]="tbl">{{tbl}}</option>
}
          </select>
        </div>
}
        @if (showWhereClauseField) {
<div class="col-md-4">
          <label>Where Clause:</label><br>
          <input type="text" class="form-control input-field-where" [(ngModel)]="rWhereClause" [ngModelOptions]="{standalone: true}">
        </div>
}
      </div>

      <br>
      <div class="row">
        <div class="col-md-1 col-md-btn gt-edit-col"></div>
        <div class="col-md-5 centerText">
          <label>Source Table Columns</label>
        </div>
        <div class="col-md-5 centerText">
          <label>Target Table Columns</label>
        </div>
      </div>
      <br>

      @for (t of matchColList; track $index; let i = $index) {
<div class="row">
        <div class="col-md-1 col-md-btn gt-edit-col">
          <input style="margin-top: 10px; margin-right: 5px" type="checkbox" [(ngModel)]="t.INCLUDE_YN" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="col-md-5 centerText">
          @if (!t.src_dropdown) {
<div>
            <input type="text" class="form-control" [(ngModel)]="t.SRC_COL_NAME" [ngModelOptions]="{standalone: true}" readonly>
          </div>
}
          @if (t.src_dropdown) {
<div>
            <select class="form-control dropdown-limited" [(ngModel)]="t.SRC_COL_NAME" [ngModelOptions]="{standalone: true}" [size]="srcColList.length > 8 ? 8 : null">
              <option [ngValue]="null">Select</option>
              @for (srcCol of srcColList; track $index) {
<option [value]="srcCol">{{srcCol}}</option>
}
            </select>
          </div>
}
        </div>
        <div class="col-md-5 centerText">
          <input type="text" class="form-control" [(ngModel)]="t.ARC_COL_NAME" [ngModelOptions]="{standalone: true}" readonly>
        </div>
      </div>
}
      <br>
    </form>
  </div>
}

  <div class="modal-footer">
    <button class="btn btn-info btn-sm" type="button" (click)="save()" [disabled]="crudLoading">
      @if (crudLoading) {
<span>
        <i class="fa fa-spinner fa-pulse"></i>
      </span>
}
      Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
}

